const homepage = window.location.origin;

const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: homepage,
  title: "Mabinogi Visual Chat Converter",
};

export { header, homepage };
